// extracted by mini-css-extract-plugin
export var locationCard = "_qf-0";